
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns20b2d1383fd71d5281900e5f7599b0e1en from './en.yaml'
            i18n.addResourceBundle('en', '20b2d1383fd71d5281900e5f7599b0e1', flattenObject(ns20b2d1383fd71d5281900e5f7599b0e1en), true, true);
        
        export default '20b2d1383fd71d5281900e5f7599b0e1';
    